import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import { rem } from 'polished';
import Heading from 'components/mediabay-ui/components/Heading';
import IconButton from 'components/mediabay-ui/components/IconButton';
import fadeIn from '../fadeInAnim';

export const StyledSlider = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #000;
`;

export const AdSlot = styled.div`
  flex: 1 0 100%;
  order: ${props => props.order};
  height: 350px;
  animation: ${fadeIn};

  @media (min-width: 1500px) {
    height: 500px;
  }
`;

export const SliderSlot = styled.div`
  position: relative;
  flex: 1 0 100%;
  order: ${props => props.order};
  background-image: ${props => (props.background ? `url(${props.background})` : '')};
  min-height: 400px;
  max-height: 450px;
  background-size: cover;
  animation: ${fadeIn};

  @media (min-width: 1500px) {
    min-height: 500px;
    max-height: 600px;
  }

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background:
      linear-gradient(to right, rgba(0,0,0,0.9) 0%,rgba(0,0,0,0.2) 60%,rgba(0,0,0,0) 90%),
      linear-gradient(to left, rgba(0,0,0,0.4) 0%,rgba(0,0,0,0) 10%);
  }
`;

export const SliderContainer = styled.div`
  display: flex;
`;

export const SliderDetails = styled.div`
  position: absolute;
  padding: 5% 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  @media (min-width: 1024px) {
    padding: 30px 100px;
    max-width: 600px;
  }

  @media (min-width: 1500px) {
    top: 0;
    bottom: 0;
  }
`;

export const NavButton = css`
  position: absolute;
  top: 0;
  bottom: 0;
  display: none;
  z-index: 2;
  outline: 0;

  @media (min-width: 700px) {
    display: block;
  }
`;

export const LeftNavButton = styled(IconButton)`
  ${NavButton};
  left: 3%;
`;

export const RightNavButton = styled(IconButton)`
  ${NavButton}
  right: 3%;
`;

export const headingStyles = css`
  color: #fff;
  font-family: 'Museo Sans Bold';
  text-transform: uppercase;
  margin: 0;
`;

export const Badge = styled.div`
  background: ${props => props.color};
  text-transform: uppercase;
  font-family: 'Museo Sans Bold';
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 24px;
  color: #fff;
`;

export const Title = styled(Heading)`
  ${headingStyles}
  font-size: ${rem('24px')};

  @media (min-width: 900px) {
    font-size: ${rem('30px')};
  }

  @media (min-width: 1200px) {
    font-size: ${rem('45px')};
  }
`;

export const Subtitle = styled(Heading)`
  ${headingStyles}
  font-size: ${rem('18px')};
  overflow: hidden;

  @media (min-width: 900px) {
    font-size: ${rem('22px')};
  }

  @media (min-width: 1200px) {
    font-size: ${rem('25px')};
  }
`;

export const Description = styled.div`
  color: #fff;
  font-size: ${rem('15px')};
  width: 60%;
  margin-top: 10px;
  text-shadow: 0 0 15px #000;

  @media (min-width: 768px) {
    font-size: ${rem('16px')};
  }

  @media (min-width: 1200px) {
    max-height: 65px;
  }
`;

const linkBasic = css`
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding: 10px 20px;
  background: ${props => theme('mode', { light: props.color, dark: props.color })};
  color: ${theme('mode', { light: '#fff', dark: '#fff' })};
  border: 1px solid;
  border-color: ${props => theme('mode', { light: props.color, dark: props.color })};
  border-radius: 24px;
  box-shadow: ${props => `0 0 20px ${props.color}`};
  transition: all .3s;

  &:hover {
    box-shadow: ${props => `0 0 50px ${props.color}`};
  }
`;

export const StyledLink = styled(Link)`
  ${linkBasic}
`;

export const StyledExternalLink = styled.a`
  ${linkBasic}
`;
